import React from 'react'
import Link from 'next/link'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { OPERATING_NATIONS } from '../constant'
import useStyles from './Cities.style.js'

const Cities = () => {
  const classes = useStyles()
  const links = OPERATING_NATIONS.map((nation) => (
    <Grid key={nation.key} item className={classes.nation}>
      <Typography className={classes.nationLabel}>{nation.label}</Typography>
      <Grid container className={classes.links}>
        {nation.cities?.map((city) => (
          <React.Fragment key={city.name}>
            {Boolean(city.link) && (
              <Link
                as={`/restaurants/around/${encodeURI(city.link)}`}
                href={`/restaurants/around/[address]`}>
                <a className={classes.cityLink}>
                  <Typography variant='body1' component='span'>
                    {city.name}
                  </Typography>
                </a>
              </Link>
            )}
            {!city.link && (
              <Typography
                key={city.name}
                variant='body1'
                component='span'
                className={classes.cityLink}>
                {city.name}
              </Typography>
            )}
          </React.Fragment>
        ))}
      </Grid>
    </Grid>
  ))

  return (
    <Grid container direction='column'>
      {links}
    </Grid>
  )
}

export default Cities
